/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class Notification implements Serializable<Notification> {


    discussionViewCount = 0;
    documentViewCount = 0;
    totalElements = 0;
    notifications: NotificationMsg[] = [];

    deserialize(input) {
        input.discussionViewCount && (this.discussionViewCount = input.discussionViewCount);
        input.documentViewCount && (this.documentViewCount = input.documentViewCount);
        input.totalElements && (this.totalElements = input.totalElements);
        if (!!input.content) {
            this.notifications = [];
            for (var i = 0; i < input.content.length; i++) {
                this.notifications.push(new NotificationMsg(input.content[i]));
            }
        }
        return this;
    }

    constructor() {

    }

}

export class NotificationMsg {
    id;
    event;
    entityId;
    entity;
    parentEntityId;
    subjectId;
    message;
    additionalProperties;
    lastMessageSent;
    silent;
    userId;
    currentUserId;

    constructor(input) {
        input.id && (this.id = input.id);
        input.body && (this.message = input.body);
        input.message && (this.message = input.message);
        input.event && (this.event = input.event);
        input.entity && (this.entity = input.entity);
        input.parentEntityId && (this.parentEntityId = input.parentEntityId);
        input.notificationDate && (this.lastMessageSent = input.notificationDate);
        input.lastMessageSent && (this.lastMessageSent = input.lastMessageSent);
        input.entityId && (this.entityId = input.entityId);
        input.subjectId && (this.subjectId = input.subjectId);
        input.currentUserId && (this.currentUserId = input.currentUserId);
        input.userId && (this.userId = input.userId);
        this.silent = input.silent;
        input.additionalProperties && (this.additionalProperties = input.additionalProperties);
    }
}
